import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import { SHOW_NOTICE } from '../notice'
import {
  SISENSE_FETCH_LIST_BY_APPLICATION,
  SISENSE_FETCH_LIST_BY_APPLICATION_SUCCESS,
  SISENSE_FETCH_LIST_BY_APPLICATION_FAILURE,
  SISENSE_FETCH_TABLE_DATA,
  SISENSE_FETCH_FORM_DATA,
  SISENSE_CHANGE,
  SISENSE_DELETE,
  SISENSE_FETCH_TABLE_DATA_SUCCESS,
  SISENSE_FETCH_TABLE_DATA_FAILURE,
  SISENSE_FETCH_FORM_DATA_SUCCESS,
  SISENSE_FETCH_FORM_DATA_FAILURE,
  LOAD_SISENSE_FORM,
} from './reducer'

function* fetchSisenseListByApplication({ payload: { slug, jsonParams, id } }) {
  try {
    const query = jsonParams
      ? `?json_params=${encodeURIComponent(
          JSON.stringify(jsonParams),
        )}&slug=${slug}`
      : ''

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(ApiRoute.SISENSE_LIST_BY_APPLICATION, {
        id,
      })}${query}`,
    })

    if (!response || !response.error) {
      yield put({
        type: SISENSE_FETCH_LIST_BY_APPLICATION_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: SISENSE_FETCH_LIST_BY_APPLICATION_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('SISENSE ERROR', error)
  }
}

function* sisenseFetchTableData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.API_URL_SISENSE_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response || !response.error) {
      yield put({ type: SISENSE_FETCH_TABLE_DATA_SUCCESS, payload: response })
    } else {
      yield put({
        type: SISENSE_FETCH_TABLE_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('SISENSE INTERFACE ERROR', error)
  }
}

function* sisenseFetchFormData(action) {
  try {
    const { payload } = action
    yield put({ type: LOAD_SISENSE_FORM, payload: true })

    const { entityId } = payload
    const formData = {
      sisense: {},
      applications: [],
    }

    formData.applications = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.APPLICATIONS_BY_LICENSEE,
    })

    if (entityId) {
      formData.sisense = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(ApiRoute.API_URL_SISENSE_ITEM, {
          id: payload.entityId,
        }),
      })
    }

    if (
      formData.applications.hasOwnProperty('error') ||
      (formData.sisense && formData.sisense.hasOwnProperty('error'))
    ) {
      yield put({ type: SISENSE_FETCH_FORM_DATA_FAILURE })
    } else {
      yield put({ type: SISENSE_FETCH_FORM_DATA_SUCCESS, payload: formData })
    }

    yield put({ type: LOAD_SISENSE_FORM, payload: false })
  } catch (error) {
    console.log('SISENSE ERROR', error)
  }
}

function* sisenseChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: !entityId ? 'POST' : 'PUT',
      partUrl: !entityId
        ? ApiRoute.API_URL_SISENSE_LIST
        : UrlHelper.create(ApiRoute.API_URL_SISENSE_ITEM, { id: entityId }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Sisense ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`SISENSE INTERFACE ERROR: ${error}`)
  }
}

function* sisenseDelete(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRoute.API_URL_SISENSE_ITEM, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Application delete successful'),
      })

      return yield sisenseFetchTableData(action)
    }

    console.log('SISENSE DELETE UNKNOWN ERROR. RESPONSE: ', response)
  } catch (error) {
    console.log('SISENSE INTERFACE ERROR', error)
  }
}

function* salesDashboardSaga() {
  yield takeLatest(
    SISENSE_FETCH_LIST_BY_APPLICATION,
    fetchSisenseListByApplication,
  )
  yield takeLatest(SISENSE_FETCH_TABLE_DATA, sisenseFetchTableData)
  yield takeLatest(SISENSE_FETCH_FORM_DATA, sisenseFetchFormData)
  yield takeLatest(SISENSE_CHANGE, sisenseChange)
  yield takeLatest(SISENSE_DELETE, sisenseDelete)
}

export default salesDashboardSaga
